module.exports = __webpack_public_path__ + "static/media/12.f01b767c.png";